module.exports = __webpack_public_path__ + "static/media/profile6.f6c7377d.jpg";